/* B&M – Avis clientes à onglets (sections/bm-reviews-tabs.liquid)
   - Onglets accessibles (rôle tablist) : clic, flèches gauche/droite, Début/Fin, tabindex « itinérant ».
   - Points de navigation synchronisés avec les onglets.
   - Balayage au doigt sur le contenu (gauche = avis suivant, droite = précédent).
   - Éditeur Shopify : sélectionner un bloc « Avis » affiche son onglet. */
(function () {
  var SWIPE_MIN = 40;

  function init(root) {
    if (!root || root.dataset.bmReviewsReady) return;
    root.dataset.bmReviewsReady = 'true';

    var tablist = root.querySelector('[data-bm-reviews-tablist]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bm-reviews-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bm-reviews-panel]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bm-reviews-dot]'));
    var panelsWrap = root.querySelector('[data-bm-reviews-panels]');
    var current = 0;

    function scrollTabIntoView(tab) {
      if (!tablist || tablist.scrollWidth <= tablist.clientWidth) return;
      var left = tab.offsetLeft - tablist.offsetLeft;
      var right = left + tab.offsetWidth;
      if (left < tablist.scrollLeft) {
        tablist.scrollLeft = left - 16;
      } else if (right > tablist.scrollLeft + tablist.clientWidth) {
        tablist.scrollLeft = right - tablist.clientWidth + 16;
      }
    }

    function select(index, focus) {
      if (!tabs.length) return;
      index = (index + tabs.length) % tabs.length;
      current = index;
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (panels[i]) panels[i].hidden = !active;
      });
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      scrollTabIntoView(tabs[index]);
      if (focus) tabs[index].focus();
    }

    function updateOverflow() {
      if (tablist) tablist.classList.toggle('is-overflowing', tablist.scrollWidth > tablist.clientWidth + 1);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i, false);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = i + 1;
        else if (event.key === 'ArrowLeft') next = i - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        select(i, false);
      });
    });

    if (panelsWrap && tabs.length > 1) {
      var startX = null;
      var startY = null;
      panelsWrap.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      panelsWrap.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        startX = null;
        // Geste surtout horizontal, sinon on laisse défiler la page.
        if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        select(dx < 0 ? current + 1 : current - 1, false);
      }, { passive: true });
    }

    updateOverflow();
    window.addEventListener('resize', updateOverflow);

    root.addEventListener('shopify:block:select', function (event) {
      var id = event.detail && event.detail.blockId;
      tabs.forEach(function (tab, i) {
        if (tab.dataset.blockId === id) select(i, false);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bm-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
